import {
  OPTIMIZELY_CONTROL_EXPERIMENT,
  OPTIMIZELY_EXPERIMENT_VARIATION_1,
  USER_UUID,
} from 'app-constants'
import platform from 'components/Trackers/platform'
import { getFlow } from 'utils/FlowProvider/utils'

export const trackDirectToMobileOptimizelyHandler = ({ trackOptimizely }) => eventName => {
  const uuid = window.sessionStorage.getItem(USER_UUID)
  const optimizelyAttributes = {
    platform,
  }
  trackOptimizely(eventName, uuid ?? undefined, optimizelyAttributes)
}

export const isFlowDirectToMobile = () => {
  return getFlow() === 'directToMobile'
}

export const userHasViewedExperiment = (variation: string): boolean => {
  const experimentVariationNames = [
    OPTIMIZELY_CONTROL_EXPERIMENT,
    OPTIMIZELY_EXPERIMENT_VARIATION_1,
  ]
  const lowerCaseExperimentVariationNames = experimentVariationNames.map(name => name.toLowerCase())
  const lowerCaseVariationName = variation.toLowerCase()
  return lowerCaseExperimentVariationNames.includes(lowerCaseVariationName)
}
